// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__OaLnp","left":"InfoRow_left__1rdVA"};